import Model from './BaseModel';
import SportEvent from './SportEvent';
import SportSelection from './SportSelection';

export default class Market extends Model {
	resourceName() {
		return 'markets';
	}

	fields() {
		return [
			'bonus_disabled',
			'boostable',
			'feed_status',
			'line',
			'manual_result',
			'name',
			'override_status',
			'rolling_type',
			'status',
			'total_score',
			'type',
			'resulted_at',
			'bet_count',
			'is_manual',
			'event_id',
			'parent_market_id',
			'liabilities',
			'multis',
			'cashout_enabled',
			'derived_market_id',
			'traded_in_play',
			'traded_pre_match'
		];
	}

	dates() {
		return ['resulted_at'];
	}

	relationships() {
		return {
			selections: new SportSelection(),
			sport_event: new SportEvent()
		};
	}

	computed() {
		return {
			display_line(market) {
				if (!market.line) return null;
				return market.line < 0 ? market.line : `+${market.line}`;
			},
			is_derived(market) {
				return market.derived_market_id !== null && market.derived_market_id != market.id;
			},
			has_derived(market) {
				return market.derived_market_id !== null && market.derived_market_id == market.id;
			}
		};
	}

	overridePrices(data) {
		return this.makePersistRequest({
			url: `${this.selfUrl()}/override_prices`,
			method: 'PATCH',
			data
		});
	}

	unresult() {
		return this.makePersistRequest({
			url: `${this.selfUrl()}/unfinalise`,
			method: 'POST'
		});
	}

	removeOverridePrices() {
		return this.makePersistRequest({
			url: `${this.selfUrl()}/override_prices`,
			method: 'DELETE'
		});
	}

	manualResult(data) {
		return this.makePersistRequest({
			url: `${this.selfUrl()}/results`,
			method: 'PATCH',
			data
		});
	}

	adjustLiabilityLimit(newSelectionLimit, newMultiSelectionLimit) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/liability_settings`,
			method: 'POST',
			data: {
				selection_limit: newSelectionLimit,
				multi_selections_limit: newMultiSelectionLimit
			}
		});
	}

	adjustLineValue(newLine) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}`,
			method: 'PATCH',
			data: {
				line: newLine
			}
		});
	}

	addSelections(selections) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/selections`,
			method: 'POST',
			data: {
				sport_selections: selections
			}
		});
	}
}
